import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone, Lock } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { IMAGES } from "@/lib/images";

const NAV = [
  { to: "/club-prive", label: "Club Privé", testid: "nav-link-club" },
  { to: "/spa-naturista", label: "Spa Naturista", testid: "nav-link-spa" },
  { to: "/calendario", label: "Calendario", testid: "nav-link-calendar" },
  { to: "/gallery", label: "Gallery", testid: "nav-link-gallery" },
  { to: "/info", label: "Chi Siamo", testid: "nav-link-info" },
  { to: "/contatti", label: "Contatti", testid: "nav-link-contacts" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { settings } = useSite();

  return (
    <header className="sticky top-0 z-40 glass border-b border-[#D4AF37]/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between">
        <a href="https://www.annunci69.it/clubprive/bari/Afrodite-Club-Prive-Puglia/80/" target="_blank" rel="noopener noreferrer" data-testid="brand-logo" className="flex items-center gap-3 leading-none">
          <img src={IMAGES.logo} alt="Afrodite" className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover border border-[#D4AF37]/40" />
          <span className="flex flex-col">
            <span className="font-display text-xl sm:text-2xl tracking-[0.15em] gold-text">AFRODITE</span>
            <span className="text-[0.55rem] sm:text-[0.6rem] tracking-[0.3em] text-[#6E6865] uppercase mt-0.5">
              Club Privé &amp; Spa · Puglia
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <Link
              key={n.to} to={n.to} data-testid={n.testid}
              className={`text-sm tracking-wide transition-colors ${
                pathname === n.to ? "text-[#D4AF37]" : "text-[#A39E9B] hover:text-[#FBF8F5]"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:+39${(settings.phone || "3331512490").replace(/\s/g, "")}`}
            className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/40 text-[#D4AF37] text-sm hover:bg-[#D4AF37]/10 transition-colors"
          >
            <Phone className="w-4 h-4" /> {settings.phone || "333 1512490"}
          </a>
          <Link to="/admin" data-testid="nav-link-admin" aria-label="Area riservata"
            className="p-2.5 rounded-full text-[#6E6865] hover:text-[#D4AF37] transition-colors">
            <Lock className="w-4 h-4" />
          </Link>
        </div>

        <button data-testid="mobile-menu-btn" className="lg:hidden text-[#FBF8F5] p-2" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden glass border-t border-[#D4AF37]/15 px-4 py-4 flex flex-col gap-1">
          {NAV.map((n) => (
            <button
              key={n.to} data-testid={`m-${n.testid}`}
              onClick={() => { navigate(n.to); setOpen(false); }}
              className="text-left py-3 px-2 text-[#A39E9B] hover:text-[#D4AF37] border-b border-white/5"
            >
              {n.label}
            </button>
          ))}
          <button onClick={() => { navigate("/admin"); setOpen(false); }}
            className="text-left py-3 px-2 text-[#6E6865] flex items-center gap-2">
            <Lock className="w-4 h-4" /> Area Riservata
          </button>
        </div>
      )}
    </header>
  );
}
